import { jsx as _jsx } from "react/jsx-runtime";
/**
 * CgMedia —— @cg_show 节点的全屏展示。
 *
 * cg_show.url 在剧本里既可能是一张静态图（png/jpg/webp/gif）也可能是一段
 * 短视频（mp4/webm/mov）。后端不区分，前端按文件扩展名二选一：
 *
 *   - video: 播放一次后停在最后一帧。autoplay 兼容 iOS/Chrome 策略需要
 *     muted + playsInline。`loop` 故意不开 —— 设计要求播完即定格，由父组件
 *     凭 onEnded 决定何时显示"继续"。
 *   - image: <img>
 *
 * 任意一边加载失败时 fallback 成深色渐变占位，避免玩家看到大黑块。
 */
import { useState } from "react";
import { detectMediaKind } from "./media-kind.js";
import { t } from "./locale.js";
export function CgMedia({ url, name, language, onVideoEnded }) {
    const [failedUrl, setFailedUrl] = useState(null);
    const failed = failedUrl === url;
    const label = name ?? t(language, "player.cgFallback");
    if (failed) {
        return (_jsx("div", { className: "flex h-full w-full items-center justify-center bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f0f1e]", children: _jsx("div", { className: "text-sm font-semibold text-white/60", children: label }) }));
    }
    const kind = detectMediaKind(url);
    if (kind === "video") {
        return (_jsx("video", { src: url, className: "h-full w-full object-contain", autoPlay: true, playsInline: true, muted: true, onEnded: onVideoEnded, onError: () => setFailedUrl(url), "aria-label": label }, url));
    }
    return (
    // eslint-disable-next-line @next/next/no-img-element
    _jsx("img", { src: url, alt: label, className: "h-full w-full object-contain", onError: () => setFailedUrl(url) }, url));
}
